import { code } from "@spscommerce/utils";

export const SpsTagExamples = {
    basic: {
        label: "Basic tag",
        examples: {
            basic: {
                template: code`
                <sps-tag class="mr-1 mb-1" kind="default">Default</sps-tag>
                <sps-tag class="mr-1 mb-1" kind="key">Key</sps-tag>
                <sps-tag class="mr-1 mb-1" kind="warning">Warning</sps-tag>
                <sps-tag class="mr-1 mb-1" kind="error">Error</sps-tag>
                <sps-tag class="mr-1 mb-1" kind="pending">Pending</sps-tag>
                <sps-tag class="mr-1 mb-1" kind="success">Success</sps-tag>
                <sps-tag class="mr-1 mb-1" kind="info">Info</sps-tag>
                `
            }
        }
    },
    withIcon: {
        label: "Tag with icon",
        examples: {
            withIcon: {
                template: code`
                <sps-tag class="mr-1 mb-1" kind="default" icon="info-circle">Default</sps-tag>
                <sps-tag class="mr-1 mb-1" kind="key" icon="checkmark">Key</sps-tag>
                <sps-tag class="mr-1 mb-1" kind="warning" icon="exclamation-triangle">Warning</sps-tag>
                <sps-tag class="mr-1 mb-1" kind="error" icon="exclamation-circle">Error</sps-tag>
                <sps-tag class="mr-1 mb-1" kind="pending" icon="ellipses">Pending</sps-tag>
                `
            }
        }
    }
};
